// dmc = dark moderate cyan
// vdc = very dark cyan
// lgy = light grayish yellow
// dgo = dark grayish orange
// vdgy = very dark grayish yellow

const themeTwo = {
    backgrounds: {
        main: 'hsl(0, 0%, 90%)',
        toggle: 'hsl(0, 5%, 81%)',
        keypad: 'hsl(0, 5%, 81%)',
        screen: 'hsl(0, 0%, 93%)'
    },

    keys: {
        'dmc-bg': 'hsl(185, 42%, 37%)',
        'vdc-shadow': 'hsl(185, 58%, 25%)',
        'orange-bg-toggle': 'hsl(25, 98%, 40%)',
        'dark-orange-shadow': 'hsl(25, 99%, 27%)',
        'lgy-bg': 'hsl(45, 7%, 89%)',
        'dgo-shadow': 'hsl(35, 11%, 61%)'
    },

    text: {
        vdgy: 'hsl(60, 10%, 19%)',
        white: 'hsl(0, 0%, 100%)'
    }
};

export default themeTwo;
